import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../components/header/Header";
import Footer from "../pages/Footer";

const Main = () => {
  const location = useLocation();

  const getRoute = () => {
    if (
      location.pathname === "/" ||
      location.pathname === "/login" ||
      location.pathname === "/quiz-exam/SIMULATION"
    ) {
      return "bg";
    } else {
      return "bg_green";
    }
  };

  return (
    <div className={`bg main_body ${getRoute()}`}>
      <div className="layout_wrapper">
        <Header />
        <div className="outlet_wrapper">
          <Outlet />
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Main;
